import { HTTP_CODE } from '@/utils/request'
import * as service from './service'
import Toast from 'antd-mobile/es/toast'
export default {
  namespace: 'goldExplain',
  state: {
    demoData: {
      type: 1,
      text: ''
    }
  },
  effects: {
    * getCityRuleDesc ({ payload }, { call, put }) {
      const res = yield call(service.cityRuleDesc, payload)
      if (res.status !== HTTP_CODE.success) {
        console.error(res.data.err)
      }
      yield put({
        type: 'save',
        payload: {
          demoData: res.data.data
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
